import React, { useState } from 'react'
import Footer from '../Layout/Footer'
import Header from '../Layout/Header'
import Sidebar from '../Layout/Sidebar'
import { useEffect } from 'react'
import { masterData, ClientList } from '../../Api/Master'
import { ProjectCreateSingle, validateFormData, cloneData } from '../../Api/Project'
import { useNavigate, useLocation } from "react-router-dom";
import { ProjecGroupChildDetail, ProjecGroupDetail, ProjectCreateGroupChild, ProjectUpdateGroupChild } from '../../Api/ProjectGroup'
import moment from 'moment'
import { format } from 'date-fns';
import { userList } from '../../Api/User'

function Group_project_child_edit() {
    const navigate = useNavigate();
    const location = useLocation();
    const queryString = new URLSearchParams(location.search)
    const id = queryString.get('id')
    useEffect(() => {
        document.title = "Group Project Child - Mindforce"
    },);

    const [clients, setClients] = useState();
    const [projectManagers, setProjectManager] = useState();
    const [countries, setCountries] = useState();
    const [languages, setLanguages] = useState();
    const [projectCategories, setProjectCategories] = useState();
    const [currencies, setCurrencies] = useState();
    const [projectFilters, setProjectFilters] = useState();
    const [selectedProjectFileter, setSelectedProjectFilter] = useState([])
    const [securityFilters, setSecurityFilters] = useState();
    const [selectedSecurityFilter, setSelectedSecurityFilter] = useState([])
    const [deviceFilters, setDeviceFilters] = useState();
    const [selectedDeviceFilter, setSelectedDeviceFilter] = useState([])
    const [detail, setDetail] = useState();
    const [uniqueIP, setUniqueIp] = useState();
    const [showUniqueIp, setShowUniqueIp] = useState(false)
    const [speeder, setSpeeder] = useState();
    const [showSpeeder, setShowSpeeder] = useState(false)
    const [uniqueIPError, setUniqueIPError] = useState()
    const [speederError, setSpeederError] = useState()
    const [form, setForm] = useState({});
    const [errors, setErrors] = useState({});
    const [deviceFilterError, setDeviceFilterError] = useState()

    useEffect(() => {
        getProjectFilters()
        getSecurityFilters()
        getDeviceFilter()
        getProjectManagers()
    }, [])

    const getProjectManagers = async () => {
        let res = await userList({ page: 0, searchKeyword: '', role: "project-manager" });

        if (res.status === 1) {
            setProjectManager(res.payload)
        }
    }

    const getProjectFilters = async () => {
        let res = await masterData({ moduleName: 'project-filters' })
        if (res.status === 1) {
            setProjectFilters(res.payload)
        }
    }

    const getSecurityFilters = async () => {
        let res = await masterData({ moduleName: 'security-filters' })
        if (res.status === 1) {
            setSecurityFilters(res.payload)
        }
    }

    const getDeviceFilter = async () => {
        let res = await masterData({ moduleName: 'device-filters' })
        if (res.status === 1) {
            setDeviceFilters(res.payload)
        }
    }




    const getDetail = async () => {
        let res = await ProjecGroupChildDetail({ id: id })
        if (res.status === 1) {
            setDetail(res.payload[0]);
            await setForm(res.payload[0])
            let pfArray = [];
            let dfArray = [];
            let sfArray = [];
            res.payload[0]?.childProjects?.[0]?.projectFilters?.map((pf, i) => {
                // console.log('pf', pf)
                if (pf.status === 1) {
                    if (pf.id === 420) {
                        setUniqueIp(pf.value)
                        setShowUniqueIp(true)
                    }
                    if (pf.id === 421) {
                        setSpeeder(pf.value)
                        setShowSpeeder(true)
                    }
                    pfArray.push(pf.id.toString())
                }
            })
            res.payload[0]?.childProjects?.[0]?.deviceFilters?.map((df, i) => {
                if (df.status === 1) {
                    dfArray.push(df.id.toString())
                }
            })
            res.payload[0]?.childProjects?.[0]?.securityFilters?.map((sf, i) => {
                if (sf.status === 1) {
                    sfArray.push(sf.id.toString())
                }
            })
            await setSelectedProjectFilter(pfArray)
            await setSelectedSecurityFilter(sfArray)
            await setSelectedDeviceFilter(dfArray)
        }

    }

    const getClients = async () => {
        let res = await ClientList({ page: 0, searchKeyword: '' })
        if (res.status === 1) {
            setClients(res.payload)
        }
    }

    const getCountries = async () => {
        let res = await masterData({ moduleName: 'country' })
        if (res.status === 1) {
            setCountries(res.payload)
        }
    }

    const getLanguages = async () => {
        let res = await masterData({ moduleName: 'language', countryID: form?.countryID })
        if (res.status === 1) {
            setLanguages(res.payload)
        }
    }

    const getProjectCategories = async () => {
        let res = await masterData({ moduleName: 'product-category' })
        if (res.status === 1) {
            setProjectCategories(res.payload)
        }
    }

    const getCurrencies = async () => {
        let res = await masterData({ moduleName: 'currency' })
        if (res.status === 1) {
            setCurrencies(res.payload)
        }
    }

    useEffect(() => {
        getClients()
        getCountries()
        getProjectCategories()
        getCurrencies()
    }, [])

    useEffect(() => {
        getLanguages()
    }, [form?.countryID])

    useEffect(() => {
        getDetail()
    }, [])

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
        if (!!errors[field])
            setErrors({
                ...errors,
                [field]: null
            })
    }

    const handleDates = (e, type) => {
        let date = Math.floor(new Date(e.target.value?.toString()).getTime() / 1000)
        switch (type) {
            case 'startDate':
                form.startDate = date
                break;
            case 'endDate':
                form.endDate = date
                break;

            default:
                break;
        }
    }
    const handleProjectFilter = (e) => {
        const { value, checked } = e.target;
        const slug = e.target.dataset?.key
        if (checked) {
            if (slug === 'unique-ip') {
                setUniqueIp(1)
                setShowUniqueIp(true)
            }
            if (slug === 'speeder') {
                setShowSpeeder(true)
            }
            if (slug === 'captcha') {
                // document.getElementById('projectFilter'+418).checked = true;
                document.getElementById('projectFilter' + 418).click();
            }
            setSelectedProjectFilter([...selectedProjectFileter, value]);
        } else {
            if (slug === 'unique-ip') {
                setUniqueIp(null)
                setShowUniqueIp(false)
            }
            if (slug === 'speeder') {
                setShowSpeeder(false)
            }
            if (slug === 'captcha') {
                // document.getElementById('projectFilter'+418).checked = false;
                document.getElementById('projectFilter' + 418).click();
            }
            setSelectedProjectFilter(selectedProjectFileter.filter((s) => s !== value));
        }
    }

    const handleSecurityFilter = (e) => {
        const { value, checked } = e.target;
        if (checked) {
            setSelectedSecurityFilter([...selectedSecurityFilter, value]);
        } else {
            setSelectedSecurityFilter(selectedSecurityFilter.filter((s) => s !== value));
        }
    }

    const handleDeviceFilter = (e) => {
        const { value, checked } = e.target;
        if (checked) {
            setSelectedDeviceFilter([...selectedDeviceFilter, value]);
        } else {
            setSelectedDeviceFilter(selectedDeviceFilter.filter((s) => s !== value));
        }
    }

    const handlesubmit = async (e) => {
        e.preventDefault();
        setErrors()
        setSpeederError()
        setUniqueIPError()
        let proFilter = [];
        let value = null;
        let uniqueIpErrorCount = 0;
        let speederErrorCount = 0;
        projectFilters?.map(p => {
            let status = 1
            if (selectedProjectFileter.indexOf(p.id.toString()) === -1) {
                status = 0;
            }
            if (p.id === 420 && status === 1) {
                if (uniqueIP) {
                    value = uniqueIP
                } else {
                    uniqueIpErrorCount = uniqueIpErrorCount + 1;
                    value = null
                }

            }
            else if (p.id === 421 && status === 1) {
                if (speeder) {
                    value = speeder
                } else {
                    speederErrorCount = speederErrorCount + 1;
                    setSpeederError("Required")
                    value = null
                }
                // value = speeder

            } else {
                value = null;
            }
            proFilter.push({ id: p.id, status: status, value: value })
        });

        let secFilter = [];
        securityFilters?.map(s => {
            let status = 1
            if (selectedSecurityFilter.indexOf(s.id.toString()) === -1) {
                status = 0;
            }
            secFilter.push({ id: s.id, status: status, value: null })
        });

        let devFilter = [];
        let isDeviceFilterExist = deviceFilters?.length;
        deviceFilters?.map(d => {
            let status = 1
            if (selectedDeviceFilter.indexOf(d.id.toString()) === -1) {
                isDeviceFilterExist = isDeviceFilterExist - 1;
                status = 0;
            }
            devFilter.push({ id: d.id, status: status, value: null })
        });
        form.projectFilters = proFilter;
        form.securityFilters = secFilter;
        form.deviceFilters = devFilter

        const formErrors = validateFormData(form)
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors)
        } else {
            if (isDeviceFilterExist < 1) {
                setDeviceFilterError("Required")
                return false;
            }
            if (uniqueIpErrorCount > 0) {
                setUniqueIPError("Required")
                return false;
            }
            if (speederErrorCount > 0) {
                setSpeederError("Required")
                return false;
            }
            let payload = {
                parentProjectID: form?.childProjects?.[0]?.parentProjectID,
                childProject: [form]
            }
            let res = await ProjectCreateGroupChild({ payload: payload });
            if (res.status === 1) {
                //navigate('/group-project-child-detail?id=' + id, { state: id });
                let projectDetailID = res?.payload.projectDetailID;
                if(form?.clonePrescreener){
                    let payload = {
                        "sourceProjectDetailID": id,
                        "destinationProjectDetailID": projectDetailID,
                        "cloneType": "prescreener"
                    }
                    cloneData({payload});
                }
                navigate("/group-project-child-detail?id=" + projectDetailID);
            } else {
                setErrors({ ...errors, ['submit']: res.message })
            }
        }
    }
    return (
        <div>
            {/* <Sidebar /> */}
            <Header />
            <div id="layout-wrapper">
                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <div>
                                            <div className="page-title-right">
                                                <ol className="breadcrumb m-0">
                                                    <li className="breadcrumb-item"><a>Project</a></li>
                                                    <li className="breadcrumb-item active">Clone Project</li>
                                                </ol>
                                            </div>
                                            <h4 className="mb-sm-0">Clone Project</h4>
                                        </div>


                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}

                            <div className="row">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="card">

                                        {/* <!-- end card header --> */}

                                        <div className="card-body">
                                            <div className="">
                                                <form >
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label mb-0">Group Project <span className="required_field">*</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter project name" disabled={true} defaultValue={detail?.fullName} />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Client <span className="required_field">*{errors?.clientID}</span></label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true" disabled={true} onChange={(e) => setField('clientID', e.target.value)}>
                                                                    <option value={""} disabled selected>Select Client</option>
                                                                    {clients?.map((client) => {
                                                                        return (<option value={client.clientID} selected={client.clientName === detail?.childProjects?.[0]?.clientName ? true : false}>{client.clientName}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="ProjectName" className="form-label mb-0">Project Name <span className="required_field">*{errors?.fullName}</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter project name" id="fullName" defaultValue={form?.fullName} onChange={(e) => setField('fullName', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        {/* <!--end col--> */}
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="ProjectManager" className="form-label mb-0">Project Manager <span className="required_field">*{errors?.managerID}</span></label>
                                                                {/* <input type="text" className="form-control" placeholder="Enter field" id="managerName" defaultValue={form?.managerName} onChange={(e) => setField('managerName',e.target.value)} /> */}
                                                                <select id="managerID" className="form-select" data-choices data-choices-sorting="true" defaultValue={form?.managerID} onChange={(e) => setField('managerID', e.target.value)}>
                                                                    <option value={""} disabled selected>Select Project Manager</option>
                                                                    {projectManagers?.map((manager) => {
                                                                        return (<option value={manager.ID} selected={form?.managerID == manager.ID ? true : false} >{manager.firstName + " " + manager.lastName}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {/* <!--end col--> */}
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Project Country <span className="required_field">*{errors?.countryID}</span></label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true" onChange={(e) => setField('countryID', e.target.value)}>
                                                                    <option value={""} selected>Select Country</option>
                                                                    {countries?.map((country) => {
                                                                        return (<option value={country.id}>{country.name}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Project Language <span className="required_field">*{errors?.languageID}</span></label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true" onChange={(e) => setField('languageID', e.target.value)}>
                                                                    <option value={""} selected>Select Language</option>
                                                                    {languages?.map((language) => {
                                                                        return (<option value={language.id}>{language.name}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Project Category <span className="required_field">*{errors?.categoryID}</span></label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true" onChange={(e) => setField('categoryID', e.target.value)}>
                                                                    <option value={""} disabled selected>Select Category</option>
                                                                    {projectCategories?.map((projectCategory) => {
                                                                        return (<option value={projectCategory.id} selected={projectCategory.id === form?.categoryID ? true : false}>{projectCategory.name}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {/* <!--end col--> */}
                                                        <div className="col-md-8">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Project Description <span className="required_field">{errors?.description}</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter project description" id="description" defaultValue={form?.description} onChange={(e) => setField('description', e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">LOI(Minute) <span className="required_field">*{errors?.loi}</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter " id="loi" defaultValue={form?.loi} onChange={(e) => setField('loi', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">IR(%) <span className="required_field">*{errors?.ir}</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter " id="Projectdescription" defaultValue={form?.ir} onChange={(e) => setField('ir', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Sample Size <span className="required_field">*{errors?.sampleSize}</span></label>
                                                                <input type="text" className="form-control" placeholder="0" id="Projectdescription" defaultValue={form?.sampleSize} onChange={(e) => setField('sampleSize', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col d-none">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Respondent Click Quota <span className="required_field">*{errors?.respondentClickQuota}</span></label>
                                                                <input type="text" className="form-control" placeholder="0" id="Projectdescription" value="10000000" />
                                                            </div>
                                                        </div>

                                                        {/*  */}
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Currency <span className="required_field">*{errors?.currencyID}</span></label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true" defaultValue={form?.currencyID} onChange={(e) => setField('currencyID', e.target.value)}>
                                                                    <option value={""} disabled selected>Select </option>
                                                                    {currencies?.map((currency) => {
                                                                        return (<option value={currency.id}>{currency.name}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {/* </div>
                                                    <div className='row'> */}
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Project CPI <span className="required_field">*{errors?.projectCPI}</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter " id="Projectdescription" defaultValue={form?.projectCPI} onChange={(e) => setField('projectCPI', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Supplier CPI <span className="required_field">*{errors?.supplierCPI}</span></label>
                                                                <input type="text" className="form-control" placeholder="0" id="Projectdescription" defaultValue={form?.supplierCPI} onChange={(e) => setField('supplierCPI', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-md-3 d-none'>
                                                            <div className="mb-3">
                                                                <label htmlFor="startDate" className="form-label mb-0">Start Date<span className="required_field">*{errors?.startDate}</span></label>
                                                                <input type="date" className="form-control" id="dateInput" defaultValue={form?.startDate ? format(new Date(form?.startDate * 1000), 'yyyy-MM-dd').toString() : ""} onChange={(e) => handleDates(e, 'startDate')} />
                                                                <input type="text" className="form-control" value={form?.startDate ? format(new Date(form?.startDate * 1000), 'dd MMM yyyy') : format(new Date(), 'dd MMM yyyy')} readOnly={true} style={{ position: "absolute", top: "20px", width: "190px", borderRightStyle: "none" }} />
                                                            </div>
                                                        </div>
                                                        <div className='col-md-3 d-none'>
                                                            <div className="mb-3">
                                                                <label htmlFor="endDate" className="form-label mb-0">End Date <span className="required_field">*{errors?.endDate}</span></label>
                                                                <input type="date" className="form-control" id="exampleInputdate" defaultValue={form?.endDate ? format(new Date(form?.endDate * 1000), 'yyyy-MM-dd').toString() : ""} onChange={(e) => handleDates(e, 'endDate')} />
                                                                <input type="text" className="form-control" value={form?.endDate ? format(new Date(form?.endDate * 1000), 'dd MMM yyyy') : format(new Date(), 'dd MMM yyyy')} readOnly={true} style={{ position: "absolute", top: "20px", width: "190px", borderRightStyle: "none" }} />
                                                            </div>
                                                        </div>



                                                        <div className="form_divide"><hr ></hr></div>
                                                        <br />

                                                        <div className='row'>
                                                            <div className='col-5 d-flex justify-content-center border-end'>
                                                                <div>

                                                                    <h1 className="project_filter">Project Filter</h1>
                                                                    <div className='row'>
                                                                        {form?.childProjects?.[0]?.projectFilters?.map((row, i) => {
                                                                            return (
                                                                                <div className="col-md-6">
                                                                                    <div className="form-check mb-3" style={{ display: "flex" }}>
                                                                                        <input className="form-check-input" type="checkbox" data-key={projectFilters?.[i]?.slug} id={"projectFilter" + row.id} value={row.id}
                                                                                            defaultChecked={row?.status === 1 ? true : false}
                                                                                            onClick={(e) => handleProjectFilter(e)}
                                                                                            style={{ marginRight: "4px" }}
                                                                                        />
                                                                                        <label className="form-check-label" htmlFor={"projectFilter" + row.id} style={{ float: "left", marginRight: "4px" }}>
                                                                                            {projectFilters?.[i]?.name}
                                                                                        </label>
                                                                                        {projectFilters?.[i]?.slug == "unique-ip" && showUniqueIp ? (<>
                                                                                            <span className="required_field">*{uniqueIPError}</span>
                                                                                            <input type="number" className="small-input" style={{ height: "20px", width: "50px" }} placeholder="" id="UniqueIP"
                                                                                                defaultValue={uniqueIP}
                                                                                                // {form?.childProjects?.[0]?.projectFilters?.[i]?.value} 
                                                                                                onChange={(e) => setUniqueIp(e.target.value)} />
                                                                                        </>) : (<></>)}
                                                                                        {projectFilters?.[i]?.slug == "speeder" && showSpeeder ? (<>
                                                                                            <span className="required_field">*{speederError}</span>
                                                                                            <input type="number" className="small-input" style={{ height: "20px", width: "50px" }} placeholder="" id="Speeder" defaultValue={form?.childProjects?.[0]?.projectFilters?.[i]?.value} onChange={(e) => setSpeeder(e.target.value)} />
                                                                                        </>) : (<></>)}
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* {projectFilters?.map((row, i) => {
    return (
        <div className="col-md-3">
            <div className="form-check mb-3" style={{display:"flex"}}>
                <input className="form-check-input" type="checkbox" id={"projectFilter"+row.id} value={row.id}
                defaultChecked={form?.childProjects?.[0]?.projectFilters?.[i]?.status === 1 ? true : false}
                onClick={(e) => handleProjectFilter(e)}
                style={{marginRight:"4px"}}
                    />
                <label className="form-check-label"htmlFor={"projectFilter"+row.id} style={{float:"left", marginRight:"4px"}}>
                    {row?.name}
                </label>
                {
                    row?.name =="Unique IP" &&
                    <input type="number" className="small-input" style={{height:"20px", width:"50px"}} placeholder="" id="UniqueIP" defaultValue={form?.childProjects?.[0]?.projectFilters?.[i]?.value} onChange={(e) => setUniqueIp(e.target.value)}  />
                }
                    {
                    projectFilters?.[i]?.name =="Speeder" &&
                    <input type="number" className="small-input" style={{height:"20px", width:"50px"}} placeholder="" id="Speeder" defaultValue={form?.childProjects?.[0]?.projectFilters?.[i]?.value} onChange={(e) => setSpeeder(e.target.value)}  /> 
                }
            </div>
        </div>
    )
})} */}

                                                            {/* <div className="form_divide"><hr ></hr></div> */}
                                                            {/* <h1 className="project_filter">Security Filter</h1>
                                                        {securityFilters?.map((row, i) => {
                                                            return (
                                                                <div className="col-md-3">
                                                                    <div className="form-check mb-3">
                                                                        <input className="form-check-input" type="checkbox" id={"securityFilter"+row.id} value={row.id} 
                                                                        defaultChecked={parseInt(row?.id) === parseInt(form?.childProjects?.[0]?.securityFilters?.[i]?.id) && parseInt(form?.childProjects?.[0]?.securityFilters?.[i]?.status) === 1 ? true : false}
                                                                        onChange={(e) => handleSecurityFilter(e)} />
                                                                        <label className="form-check-label"htmlFor={"securityFilter"+row.id}>
                                                                            {row.name}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })} */}
                                                            <div className='col d-flex justify-content-center border-end'>
                                                                <div>

                                                                    <h1 className="project_filter">Security Filter</h1>
                                                                    {form?.childProjects?.[0]?.securityFilters?.map((row, i) => {
                                                                        return (
                                                                            <div className="">
                                                                                <div className="form-check mb-3">
                                                                                    <input className="form-check-input" type="checkbox" id={"securityFilter" + row.id} value={row.id}
                                                                                        defaultChecked={row?.status === 1 ? true : false}
                                                                                        onChange={(e) => handleSecurityFilter(e)} />
                                                                                    <label className="form-check-label" htmlFor={"securityFilter" + row.id}>
                                                                                        {securityFilters?.[i]?.name}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>

                                                            {/* <div className="form_divide"><hr ></hr></div> */}
                                                            {/* <h1 className="project_filter">Device Filter <span className="required_field">*{deviceFilterError}</span></h1>
                                                        {deviceFilters?.map((row, i) => {
                                                            return (
                                                                <div className="col-md-3">
                                                                    <div className="form-check mb-3">
                                                                        <input className="form-check-input" type="checkbox" id={"deviceFilter"+row.id} value={row.id} 
                                                                        defaultChecked={parseInt(row?.id) === parseInt(form?.childProjects?.[0]?.deviceFilters?.[i]?.id) && parseInt(form?.childProjects?.[0]?.deviceFilters?.[i]?.status) === 1 ? true : false}
                                                                        onChange={(e) => handleDeviceFilter(e)} />
                                                                        <label className="form-check-label"htmlFor={"deviceFilter"+row.id}>
                                                                            {row.name}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })} */}
                                                            <div className='col d-flex justify-content-center'>
                                                                <div>

                                                                    <h1 className="project_filter">Device Filter <span style={{color: "red"}}>*</span></h1>
                                                                    {form?.childProjects?.[0]?.deviceFilters?.map((row, i) => {
                                                                        return (
                                                                            <div className="">
                                                                                <div className="form-check mb-3">
                                                                                    <input className="form-check-input" type="checkbox" id={"deviceFilter" + row.id} value={row.id}
                                                                                        defaultChecked={row?.status === 1 ? true : false}
                                                                                        onChange={(e) => handleDeviceFilter(e)} />
                                                                                    <label className="form-check-label" htmlFor={"deviceFilter" + row.id}>
                                                                                        {deviceFilters?.[i]?.name}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <br />
                                                        <div className="form_divide"><hr ></hr></div>
                                                        <div className="col-md-12">
                                                            <div className="mb-3">
                                                                <label htmlFor="exampleFormControlTextarea5" className="form-label mb-0">Notes </label>
                                                                <textarea className="form-control" id="exampleFormControlTextarea5" rows="3" defaultValue={form?.childProjects?.[0]?.notes} onChange={(e) => setField('notes', e.target.value)}></textarea>
                                                                <span className="max_char">Maximum limit of characters 250</span>
                                                            </div>
                                                        </div>


                                                        <div className="col-lg-12">
                                                            <div className="text-end">
                                                                <input
                                                                    type='checkbox'
                                                                    name='clonePreScreener'
                                                                    checked={!!form.clonePrescreener}
                                                                    onChange={e => setField('clonePrescreener', e.target.checked)}
                                                                /> Clone PreScreen
                                                                <button type="submit" className="btn btn-primary mx-2" onClick={handlesubmit}>Submit</button>
                                                                <button type="submit" className="btn btn-secondary" onClick={() => navigate('/group-project-child-detail?id=' + id, { state: id })}>Cancel</button>
                                                            </div>
                                                        </div>


                                                        {/* <!--end col--> */}
                                                    </div>
                                                    {/* <!--end row--> */}
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Group_project_child_edit